export const mergeAlertsPage = (previousAlerts, currentAlerts, page) => {
  if (page === 0) return currentAlerts

  const alertsById = new Map(
    previousAlerts.map((alert) => [alert?._id, alert])
  )

  currentAlerts.forEach((alert) => {
    alertsById.set(alert?._id, alert)
  })

  return [...alertsById.values()]
}
